module.exports = function () {
    $('.selected-name').text($('.hub-page-filter-list-item.is-active').text());

    function setFilterListWrapperHeight() {
        setTimeout(function() {
            var MOBILE_BREAKPOINT = "992";
            var wrapperHeight;

            if ($('.hub-page-filter-list-wrapper').hasClass('is-active')) {
                wrapperHeight = $('.filter-selected').outerHeight(true) + $('.hub-page-filter-list').outerHeight(true);
            }
            else {
                wrapperHeight = window.innerWidth < MOBILE_BREAKPOINT ? $('.filter-selected').outerHeight(true) : $('.filter-selected').outerHeight(true) + $('.hub-page-filter-list').outerHeight(true);
            }

            $('.hub-page-filter-list-wrapper').height(wrapperHeight);
        }, 1);
    };

    setFilterListWrapperHeight();
    
    $('.hub-page-filter-list-item').click(function () {
        $(this).addClass('is-active');
        $(this).siblings().removeClass('is-active');

        var filterIndex = $(this).data('hub-page-filter-index');

        $('.hub-page-filtered-content:not([data-hub-page-filtered-index="' + filterIndex + '"])').removeClass('is-active');

        $('.hub-page-filtered-content[data-hub-page-filtered-index="' + filterIndex + '"]').addClass('is-active');

        $('.selected-name').text($(this).text());
        $('.selected-index-value').text($(this).index() + 1);

        $('.filter-selected').parent().removeClass('is-active');
        setFilterListWrapperHeight();
        AOS.refresh();
    });

    $('.filter-selected').click(function () {
        $(this).parent().toggleClass('is-active');
        setFilterListWrapperHeight();
    });

    $(window).on('resize', function() {
        setFilterListWrapperHeight();
    });
};